import { GameTypeStudent } from "screens/StudentFolder/StudentFolder";
import { AppThunk } from "..";
import { fetchRequest } from "../../utils/restApiCleintAxios";
import { setSimpleField, setTriggerAlert } from "../users/slice";
import { setPlayerLevel, updateGameMultiple } from "./slice";
import { localStorageKeys } from "config/localStorageKeys";

export const getCourses = (): AppThunk => async (dispatch) => {
  try {
    dispatch(
      setSimpleField({
        type: "isLoading",
        value: true
      })
    );
    const res = await fetchRequest("api/Exercise/GetCourses", {
      method: "post"
    });

    return Promise.resolve(res.data);
  } catch (err) {
    return Promise.reject(err);
  } finally {
    dispatch(
      setSimpleField({
        type: "isLoading",
        value: false
      })
    );
  }
};

export const getAllBiddingCourses = (): AppThunk => async (dispatch, getState) => {
  try {
    dispatch(
      setSimpleField({
        type: "isLoading",
        value: true
      })
    );

    const token = getState().user.client.ctoken;
    const userInfoStr = localStorage.getItem(localStorageKeys.userInfo);
    let userInfoParse: any = {};
    if (userInfoStr) {
      userInfoParse = JSON.parse(userInfoStr);
    }

    const res = await fetchRequest("api/Bid/GetCoursesAll", {
      method: "post",
      data: {
        ctoken: token || userInfoParse?.ctoken
      }
    });
    if (res.data?.Results) {
      let allCourses = [];
      res.data?.Results?.forEach((val) => {
        if (val?.parent?.columns) {
          val?.parent?.columns?.forEach((column: any) => {
            if (Array.isArray(column?.courses) && column?.courses?.length) {
              // eslint-disable-next-line no-unsafe-optional-chaining
              allCourses = [...allCourses, ...column?.courses];
            }
          });
        }
      });
      localStorage.setItem(localStorageKeys.setAllCoursesBidding, JSON.stringify(allCourses));
    }
    return res.data;
  } catch (err) {
    return Promise.reject(err);
  }
};

export const getSummaries = (): AppThunk => async (dispatch, getState) => {
  try {
    dispatch(
      setSimpleField({
        type: "isLoading",
        value: true
      })
    );

    const token = getState().user.client.ctoken;
    const userInfoStr = localStorage.getItem(localStorageKeys.userInfo);
    let userInfoParse: any = {};
    if (userInfoStr) {
      userInfoParse = JSON.parse(userInfoStr);
    }

    const res = await fetchRequest("api/Bid/GetSummaries", {
      method: "post",
      data: {
        ctoken: token || userInfoParse?.ctoken
      }
    });

    return res.data;
  } catch (err) {
    return Promise.reject(err);
  } finally {
    dispatch(
      setSimpleField({
        type: "isLoading",
        value: false
      })
    );
  }
};

export const getCoursesInteractiveBidding = (): AppThunk => async (dispatch) => {
  try {
    dispatch(
      setSimpleField({
        type: "isLoading",
        value: true
      })
    );
    const res = await fetchRequest("api/Bid/GetCourses", {
      method: "post"
    });

    return Promise.resolve(res.data);
  } catch (err) {
    return Promise.reject(err);
  } finally {
    dispatch(
      setSimpleField({
        type: "isLoading",
        value: false
      })
    );
  }
};

export const getCoursesHandPlay = (): AppThunk => async (dispatch) => {
  try {
    dispatch(
      setSimpleField({
        type: "isLoading",
        value: true
      })
    );
    const res = await fetchRequest("api/PHF/GetCourses", {
      method: "post"
    });

    if (res.data?.Results) {
      localStorage.setItem(localStorageKeys.listCoursesTechnique, JSON.stringify(res.data.Results));
      localStorage.setItem(
        localStorageKeys.listCoursesTechniqueHandPlay,
        JSON.stringify(res.data.Results)
      );
    }

    return Promise.resolve(res.data);
  } catch (err) {
    return Promise.reject(err);
  } finally {
    dispatch(
      setSimpleField({
        type: "isLoading",
        value: false
      })
    );
  }
};

export const getCoursesDeffensePlay = (): AppThunk => async (dispatch) => {
  try {
    dispatch(
      setSimpleField({
        type: "isLoading",
        value: true
      })
    );
    const res = await fetchRequest("api/PHDefense/GetCourses", {
      method: "post"
    });

    if (res.data?.Results) {
      localStorage.setItem(localStorageKeys.listCoursesTechnique, JSON.stringify(res.data.Results));
      localStorage.setItem(
        localStorageKeys.listCoursesTechniqueDeffense,
        JSON.stringify(res.data.Results)
      );
    }

    return Promise.resolve(res.data);
  } catch (err) {
    return Promise.reject(err);
  } finally {
    dispatch(
      setSimpleField({
        type: "isLoading",
        value: false
      })
    );
  }
};

export const getCoursesTricksPlay = (): AppThunk => async (dispatch) => {
  try {
    dispatch(
      setSimpleField({
        type: "isLoading",
        value: true
      })
    );
    const res = await fetchRequest("api/PHMini/GetCourses", {
      method: "post"
    });

    return Promise.resolve(res.data);
  } catch (err) {
    return Promise.reject(err);
  } finally {
    dispatch(
      setSimpleField({
        type: "isLoading",
        value: false
      })
    );
  }
};

export const getCoursesMinibridge = (): AppThunk => async (dispatch) => {
  try {
    dispatch(
      setSimpleField({
        type: "isLoading",
        value: true
      })
    );
    const res = await fetchRequest("api/Minibridge/GetCourses", {
      method: "post"
    });

    return Promise.resolve(res.data);
  } catch (err) {
    return Promise.reject(err);
  } finally {
    dispatch(
      setSimpleField({
        type: "isLoading",
        value: false
      })
    );
  }
};

export const getCoursesDefLeadPlay = (): AppThunk => async (dispatch) => {
  try {
    dispatch(
      setSimpleField({
        type: "isLoading",
        value: true
      })
    );
    const res = await fetchRequest("api/DefLead/GetCourses", {
      method: "post"
    });

    return Promise.resolve(res.data);
  } catch (err) {
    return Promise.reject(err);
  } finally {
    dispatch(
      setSimpleField({
        type: "isLoading",
        value: false
      })
    );
  }
};

export const loadGameHandPlay =
  (cours: number, exercise: number): AppThunk =>
  async (dispatch, getData) => {
    try {
      const ctoken = getData().user.client.ctoken;
      const res = await fetchRequest("api/PHFHandler/LoadGame", {
        method: "post",
        data: {
          CourseId: cours,
          ExerciseId: exercise,
          Language: "He",
          ctoken
        }
      });

      if (!res.data?.Token) {
        return res;
      }

      dispatch(
        updateGameMultiple({
          type_game: "handPlay",
          data: {
            token: res.data?.Token
          }
        })
      );
      return res;
    } catch {
      dispatch(
        setTriggerAlert({
          show: true,
          title: "משהו השתבש"
        })
      );
    }
  };

export const loadGameDeffense =
  (courseIdParams?: number, gameIdParams?: number): AppThunk =>
  async (dispatch, getState) => {
    try {
      const { courseId, gameId } = getState().game.gameInfoDeffensePlay;
      const ctoken = getState().user.client.ctoken;

      const res = await fetchRequest("api/PHDefenseHandler/LoadGame", {
        method: "post",
        data: {
          CourseId: courseIdParams || courseId,
          ExerciseId: gameIdParams || gameId,
          Language: "He",
          ctoken
        }
      });

      dispatch(
        updateGameMultiple({
          type_game: "deffense",
          data: {
            token: res.data?.Token
          }
        })
      );
      return res;
    } catch {
      dispatch(
        setTriggerAlert({
          show: true,
          title: "משהו השתבש"
        })
      );
    }
  };

export const loadGameTricks =
  (courseIdParams?: number, gameIdParams?: number): AppThunk =>
  async (dispatch, getState) => {
    try {
      const { courseId, gameId } = getState().game.gameInfoTricksPlay;
      const ctoken = getState().user.client.ctoken;
      const res = await fetchRequest("api/PHMiniHandler/LoadGame", {
        method: "post",
        data: {
          CourseId: courseIdParams || courseId,
          ExerciseId: gameIdParams || gameId,
          Language: "He",
          ctoken
        }
      });

      dispatch(
        updateGameMultiple({
          type_game: "tricks",
          data: {
            token: res.data?.Token
          }
        })
      );
      return res;
    } catch {
      dispatch(
        setTriggerAlert({
          show: true,
          title: "משהו השתבש"
        })
      );
    }
  };

export const getPreCardsHandPlay = (): AppThunk => async (_, getState) => {
  try {
    const { token } = getState().game.gameInfoHandPlay;
    const res = await fetchRequest("api/PHFHandler/GetPreCardSet", {
      method: "post",
      data: {
        userToken: token
      }
    });
    return res;
  } catch {
    //
  }
};

export const getRoundSetHandPlay =
  (hand: "S" | "W" | "N" | "E", isZero?: boolean): AppThunk =>
  async (dispatch, getState) => {
    try {
      const userInfoStr = localStorage.getItem(localStorageKeys.userInfo);
      let userInfoParse: any = {};
      if (userInfoStr) {
        userInfoParse = JSON.parse(userInfoStr);
      }
      const res = await fetchRequest(
        `api/PHFHandler/${isZero ? "GameRoundsSet0" : "GameRoundsSet"}`,
        {
          method: "post",
          data: {
            hand,
            userToken: getState().game.gameInfoHandPlay.token || userInfoParse?.ctoken
          }
        }
      );
      return res.data;
    } catch {
      //
    }
  };

export const getRoundSetDeffensePlay =
  (hand: "S" | "W" | "N" | "E", isZero?: boolean): AppThunk =>
  async (dispatch, getState) => {
    try {
      const res = await fetchRequest(
        `api/PHDefenseHandler/${isZero ? "GameRoundsSet0" : "GameRoundsSet"}`,
        {
          method: "post",
          data: {
            hand,
            userToken: getState().game.gameInfoDeffensePlay.token
          }
        }
      );
      return res.data;
    } catch {
      //
    }
  };

export const getRoundSetTricksPlay =
  (hand: "S" | "W" | "N" | "E", isZero?: boolean): AppThunk =>
  async (dispatch, getState) => {
    try {
      const res = await fetchRequest(
        `api/PHMiniHandler/${isZero ? "GameRoundsSet0" : "GameRoundsSet"}`,
        {
          method: "post",
          data: {
            hand,
            userToken: getState().game.gameInfoTricksPlay.token
          }
        }
      );
      return res.data;
    } catch {
      //
    }
  };

export const getPreCardsDeffense = (): AppThunk => async (dispatch, getState) => {
  try {
    const res = await fetchRequest("api/PHDefenseHandler/GetPreCardSet", {
      method: "post",
      data: {
        userToken: getState().game.gameInfoDeffensePlay.token
      }
    });
    return res.data;
  } catch {
    //
  }
};

export const getPreCardsTricks = (): AppThunk => async (dispatch, getState) => {
  try {
    const res = await fetchRequest("api/PHMiniHandler/GetPreCardSet", {
      method: "post",
      data: {
        userToken: getState().game.gameInfoTricksPlay.token
      }
    });
    return res.data;
  } catch {
    //
  }
};

export const getHandPlayInfo = (): AppThunk => async (dispatch) => {
  try {
    //
  } catch {
    //
  }
};

export const playHandPlayAuto = (): AppThunk => async (dispatch, getState) => {
  try {
    const res = await fetchRequest("api/PHFHandler/AutoPlayHand", {
      method: "post",
      data: {
        userToken: getState().game.gameInfoHandPlay.token
      }
    });

    return res.data;
  } catch (err) {
    return Promise.reject(err);
  }
};

export const playDeffenseAuto = (): AppThunk => async (dispatch, getState) => {
  try {
    const res = await fetchRequest("api/PHDefenseHandler/AutoPlayHand", {
      method: "post",
      data: {
        userToken: getState().game.gameInfoDeffensePlay.token
      }
    });
    return res.data;
  } catch (err) {
    return Promise.reject(err);
  }
};

export const tricksDeffenseAuto = (): AppThunk => async (dispatch, getState) => {
  try {
    const res = await fetchRequest("api/PHMiniHandler/AutoPlayHand", {
      method: "post",
      data: {
        userToken: getState().game.gameInfoTricksPlay.token
      }
    });
    return res.data;
  } catch {
    //
  }
};

export const getCountHandPlay = (): AppThunk => async (dispatch, getState) => {
  try {
    const userInfoStr = localStorage.getItem(localStorageKeys.userInfo);
    let userInfoParse: any = {};
    if (userInfoStr) {
      userInfoParse = JSON.parse(userInfoStr);
    }
    const res = await fetchRequest("api/PHFHandler/GetGameCount", {
      method: "post",
      data: {
        userToken: getState().game.gameInfoHandPlay.token || userInfoParse?.ctoken
      }
    });
    return res.data;
  } catch (err) {
    dispatch(
      setTriggerAlert({
        show: true,
        title: "משהו השתבש"
      })
    );
    return Promise.reject(err);
    //
  }
};

export const getInfoHandPlay = (): AppThunk => async (dispatch, getState) => {
  try {
    const userInfoStr = localStorage.getItem(localStorageKeys.userInfo);
    let userInfoParse: any = {};
    if (userInfoStr) {
      userInfoParse = JSON.parse(userInfoStr);
    }
    const res = await fetchRequest("api/PHFHandler/GameInfo", {
      method: "post",
      data: {
        userToken: getState().game.gameInfoHandPlay.token || userInfoParse?.ctoken
      }
    });
    return res.data;
  } catch (err) {
    dispatch(
      setTriggerAlert({
        show: true,
        title: "משהו השתבש"
      })
    );
    return Promise.reject(err);
    //
  }
};

export const getInfoDeffense = (): AppThunk => async (dispatch, getState) => {
  try {
    const res = await fetchRequest("api/PHDefenseHandler/GameInfo", {
      method: "post",
      data: {
        userToken: getState().game.gameInfoDeffensePlay.token
      }
    });
    return res.data;
  } catch (err) {
    dispatch(
      setTriggerAlert({
        show: true,
        title: "משהו השתבש"
      })
    );
    return Promise.reject(err);
    //
  }
};

export const getCountDeffenser = (): AppThunk => async (dispatch, getState) => {
  try {
    const res = await fetchRequest("api/PHDefenseHandler/GetGameCount", {
      method: "post",
      data: {
        userToken: getState().game.gameInfoDeffensePlay.token
      }
    });
    return res.data;
  } catch (err) {
    dispatch(
      setTriggerAlert({
        show: true,
        title: "משהו השתבש"
      })
    );
    return Promise.reject(err);
    //
  }
};

export const getCountTricks = (): AppThunk => async (dispatch, getState) => {
  try {
    const res = await fetchRequest("api/PHMiniHandler/GetGameCount", {
      method: "post",
      data: {
        userToken: getState().game.gameInfoTricksPlay.token
      }
    });

    return res.data;
  } catch (err) {
    dispatch(
      setTriggerAlert({
        show: true,
        title: "משהו השתבש"
      })
    );
    return Promise.reject(err);
    //
  }
};

export const playHandPlay =
  (val: number, suit: number): AppThunk =>
  async (dispatch, getState) => {
    try {
      const res = await fetchRequest("api/PHFHandler/PlayCard", {
        method: "post",
        data: {
          userToken: getState().game.gameInfoHandPlay.token,
          val,
          suit
        }
      });

      return res.data;
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const deffensePlay =
  (val: number, suit: number): AppThunk =>
  async (dispatch, getState) => {
    try {
      const res = await fetchRequest("api/PHDefenseHandler/PlayCard", {
        method: "post",
        data: {
          userToken: getState().game.gameInfoDeffensePlay.token,
          val,
          suit
        }
      });

      return res.data;
    } catch {
      //
    }
  };

export const tricksPlay =
  (val: number, suit: number): AppThunk =>
  async (dispatch, getState) => {
    try {
      const res = await fetchRequest("api/PHMiniHandler/PlayCard", {
        method: "post",
        data: {
          userToken: getState().game.gameInfoTricksPlay.token,
          val,
          suit
        }
      });

      return res.data;
    } catch {
      //
    }
  };

export const getSubjectHandPlay = (): AppThunk => async () => {
  try {
    const res = await fetchRequest("api/PHF/GetSubjects", {
      method: "post"
    });

    return res;
  } catch {
    //
  }
};

export const getSubjectHandPlayById = (): AppThunk => async (dispatch, getState) => {
  try {
    const SubjectIds = localStorage.getItem("subject_hand_play");

    const res = await fetchRequest("api/PHF/GetExercisesBySubjects", {
      method: "post",
      data: {
        SubjectIds: SubjectIds || getState().game.subjectIdsHandPlay
      }
    });

    return res?.data;
  } catch {
    //
  }
};

export const getSubjectDeffenseById = (): AppThunk => async (dispatch, getState) => {
  try {
    const SubjectIds = localStorage.getItem("subject_deffense_play");

    const res = await fetchRequest("api/PHDefense/GetExercisesBySubjects", {
      method: "post",
      data: {
        SubjectIds: SubjectIds || getState().game.subjectIdsDeffense
      }
    });

    return res?.data;
  } catch (err) {
    //
  }
};

export const getSubjectDeffensePlay = (): AppThunk => async () => {
  try {
    const res = await fetchRequest("api/PHDefense/GetSubjects", {
      method: "post"
    });

    return res;
  } catch {
    //
  }
};

export const getStudentFolder =
  (type: GameTypeStudent): AppThunk =>
  async (_, getState) => {
    try {
      const token = getState().user.client.ctoken;
      const userInfoStr = localStorage.getItem(localStorageKeys.userInfo);
      let userInfoParse: any = {};
      if (userInfoStr) {
        userInfoParse = JSON.parse(userInfoStr);
      }

      if (type === "bidding") {
        const res = await fetchRequest(
          `api/PlayerInfo/GetPlayerCourseInfoBidBasic?playerActiveSessionId=${
            token || userInfoParse?.ctoken
          }`,
          {
            method: "get"
          }
        );
        return res.data;
      } else if (type === "handPlay") {
        const res = await fetchRequest(
          `api/PlayerInfo/GetPlayerCourseInfoPlayHand?playerActiveSessionId=${
            token || "ugrny4iesoxmsv55peuj0m45"
          }`,
          {
            method: "get"
          }
        );
        return res.data;
      } else if (type === "deffense") {
        const res = await fetchRequest(
          `api/PlayerInfo/GetPlayerCourseInfoPHdef?playerActiveSessionId=${
            token || "ugrny4iesoxmsv55peuj0m45"
          }`,
          {
            method: "get"
          }
        );
        return res.data;
      } else if (type === "tricks") {
        const res = await fetchRequest(
          `api/PlayerInfo/GetPlayerCourseInfoPHmini?playerActiveSessionId=${
            token || "ugrny4iesoxmsv55peuj0m45"
          }`,
          {
            method: "get"
          }
        );
        return res.data;
      } else if (type === "defLead") {
        const res = await fetchRequest(
          `api/PlayerInfo/GetPlayerCourseInfoDefLead?playerActiveSessionId=${
            token || "ugrny4iesoxmsv55peuj0m45"
          }`,
          {
            method: "get"
          }
        );
        return res.data;
      } else if (type === "miniBridge") {
        const res = await fetchRequest(
          `api/PlayerInfo/GetPlayerCourseInfoMiniBridge?playerActiveSessionId=${
            token || "ugrny4iesoxmsv55peuj0m45"
          }`,
          {
            method: "get"
          }
        );
        return res.data;
      }
    } catch {
      //
    }
  };

export const setLevels =
  (levels: string[]): AppThunk =>
  async (dispatch, getState) => {
    try {
      const levelsStr = levels.join("_");

      const res = await fetchRequest("api/PlayerInfo/SetPlayerLevel", {
        method: "post",
        data: {
          sid: getState().user.client.ctoken,
          level: levelsStr
        }
      });

      dispatch(setPlayerLevel(levelsStr));

      return res;
    } catch {
      //
    }
  };

export const getLevels = (): AppThunk<Promise<void>> => async (dispatch, getState) => {
  try {
    const res = await fetchRequest(
      `api/PlayerInfo/GetPlayerLevel?playerActiveSessionId=${getState().user.client.ctoken}`,
      {
        method: "get"
      }
    );

    const levels = res?.data?.levels ?? "";

    dispatch(setPlayerLevel(levels));
  } catch (error) {
    console.error("Failed to fetch levels:", error);
    dispatch(setPlayerLevel(""));
  }
};

// Mini Bridge thunk actions
export const loadGameMiniBridge =
  (courseIdParams?: number, exerciseIdParams?: number): AppThunk =>
  async (dispatch, getState) => {
    try {
      const { courseId, globalGameId } = getState().game.gameInfoMiniBridge;
      const ctoken = getState().user.client.ctoken;
      const res = await fetchRequest("api/MinibridgeHandler/LoadGame", {
        method: "post",
        data: {
          CourseId: courseIdParams || courseId,
          ExerciseId: exerciseIdParams || globalGameId,
          Language: "He",
          ctoken
        }
      });

      dispatch(
        updateGameMultiple({
          type_game: "mini_bridge",
          data: {
            token: res.data?.Token
          }
        })
      );
      return res;
    } catch {
      dispatch(
        setTriggerAlert({
          show: true,
          title: "משהו השתבש"
        })
      );
    }
  };

export const checkContractMiniBridge =
  (contract: string): AppThunk =>
  async (dispatch, getState) => {
    try {
      const { token } = getState().game.gameInfoMiniBridge;
      const res = await fetchRequest("api/MinibridgeHandler/CheckContract", {
        method: "post",
        data: {
          ctoken: token,
          Contract: contract
        }
      });
      return res.data;
    } catch {
      dispatch(
        setTriggerAlert({
          show: true,
          title: "משהו השתבש"
        })
      );
    }
  };

export const getRoundSetMiniBridge =
  (hand: "S" | "W" | "N" | "E", isZero?: boolean): AppThunk =>
  async (dispatch, getState) => {
    try {
      const res = await fetchRequest(
        `api/MinibridgeHandler/${isZero ? "GameRoundsSet0" : "GameRoundsSet"}`,
        {
          method: "post",
          data: {
            hand,
            userToken: getState().game.gameInfoMiniBridge.token
          }
        }
      );
      return res.data;
    } catch {
      //
    }
  };

export const getPreCardsMiniBridge = (): AppThunk => async (dispatch, getState) => {
  try {
    const res = await fetchRequest("api/MinibridgeHandler/GetPreCardSet", {
      method: "post",
      data: {
        userToken: getState().game.gameInfoMiniBridge.token
      }
    });
    return res.data;
  } catch {
    //
  }
};

export const getCountMiniBridge = (): AppThunk => async (dispatch, getState) => {
  try {
    const res = await fetchRequest("api/MinibridgeHandler/GetGameCount", {
      method: "post",
      data: {
        userToken: getState().game.gameInfoMiniBridge.token
      }
    });

    const data = res.data;
    // Normalize Mini Bridge response to GameCounts array format:
    // [Score_NS, Score_EW, Hand, isDDMakeable]
    if (data && !data.GameCounts) {
      return {
        GameCounts: [data.Score_NS, data.Score_EW, data.Hand, data.isDDMakeable],
        bestContract: data.bestContract,
        difference: data.difference,
        targetContract: data.targetContract,
        targetContractScore: data.targetContractScore
      };
    }
    return data;
  } catch (err) {
    dispatch(
      setTriggerAlert({
        show: true,
        title: "משהו השתבש"
      })
    );
    return Promise.reject(err);
  }
};

export const playMiniBridgeAuto = (): AppThunk => async (dispatch, getState) => {
  try {
    const res = await fetchRequest("api/MinibridgeHandler/AutoPlayHand", {
      method: "post",
      data: {
        userToken: getState().game.gameInfoMiniBridge.token
      }
    });
    return res.data;
  } catch {
    //
  }
};

export const miniBridgePlay =
  (val: number, suit: number): AppThunk =>
  async (dispatch, getState) => {
    try {
      const res = await fetchRequest("api/MinibridgeHandler/PlayCard", {
        method: "post",
        data: {
          userToken: getState().game.gameInfoMiniBridge.token,
          val,
          suit
        }
      });

      return res.data;
    } catch {
      //
    }
  };

export const goToEndMiniBridge = (): AppThunk => async (dispatch, getState) => {
  try {
    const res = await fetchRequest("api/MinibridgeHandler/GoToEnd", {
      method: "post",
      data: {
        userToken: getState().game.gameInfoMiniBridge.token
      }
    });
    return res.data;
  } catch {
    //
  }
};

export const playCardBackMiniBridge =
  (cardsPlayed: number): AppThunk =>
  async (dispatch, getState) => {
    try {
      const res = await fetchRequest("api/MinibridgeHandler/PlayCardBack", {
        method: "post",
        data: {
          userToken: getState().game.gameInfoMiniBridge.token,
          cardsPlayed
        }
      });
      return res.data;
    } catch {
      //
    }
  };
